import { SPONSORS, type Sponsor } from './sponsors.constants.ts'

export const SIGNUP_CLOSE_DATE = '2025-04-16'

export const REGISTRATION = {
	registrationOpenDate: '2025-01-25 00:00',
	registrationCloseDate: '2025-02-16',
	registrationFullyCloseDate: '2025-02-16',
	withdrawCloseDate: '2025-02-16',
	price: 150,
	totalSlots: 130,
}

export const EVENTS = [
	{
		id: 't1-april',
		eventName: 'Thunderhawk',
		eventDate: '2025-04-26',
		eventTime: '13:00',
		eventTZ: 'America/Chicago',
		eventLocation:
			'Thunderhawk Golf Club, 39700 N Lewis Ave, Beach Park, IL 60099, United States',
		registrationOpenDate: '2025-04-05 08:00',
		registrationCloseDate: '2025-04-12',
		withdrawCloseDate: '2025-04-12',
		eventPrice: 120,
		imgSrc: '/img/events/thunderhawk.jpeg',
		totalSlots: 120,
		waitlistSlots: 12,
		sponsors: [SPONSORS[2]] as Sponsor[],
	},
	{
		id: 't2-may',
		eventName: 'WhiteTail Ridge',
		eventDate: '2025-05-17',
		eventTime: '13:00',
		eventTZ: 'America/Chicago',
		eventLocation:
			'Whitetail Ridge Golf Club, 7671 Clubhouse Dr, Yorkville, IL 60560, United States',
		registrationOpenDate: '2025-04-27 08:00',
		registrationCloseDate: '2025-05-09',
		withdrawCloseDate: '2025-05-09',
		eventPrice: 110,
		imgSrc: '/img/events/whitetail.jpeg',
		totalSlots: 120,
		waitlistSlots: 32,
		sponsors: [SPONSORS[6]] as Sponsor[],
	},
	{
		id: 't3-june',
		eventName: 'Village Links',
		eventDate: '2025-06-21',
		eventTime: '14:00',
		eventTZ: 'America/Chicago',
		eventLocation:
			'Village Links Golf Club, 1000 Village Links Dr, Oswego, IL 60543, United States',
		registrationOpenDate: '2025-05-18 08:00',
		registrationCloseDate: '2025-06-08',
		withdrawCloseDate: '2025-06-08',
		eventPrice: 140,
		imgSrc: '/img/events/village.png',
		totalSlots: 88,
		waitlistSlots: 32,
		sponsors: [SPONSORS[1]] as Sponsor[],
	},
	{
		id: 't4-july',
		eventName: 'Foxford Hills',
		eventDate: '2025-07-19',
		eventTime: '13:00',
		eventTZ: 'America/Chicago',
		eventLocation:
			'Foxford Hills Golf Club, 6800 S Rawson Bridge Rd, Cary, IL 60013, United States',
		registrationOpenDate: '2025-06-22 08:00',
		registrationCloseDate: '2025-07-08',
		withdrawCloseDate: '2025-07-08',
		eventPrice: 120,
		imgSrc: '/img/events/foxford.png',
		totalSlots: 88,
		waitlistSlots: 32,
		sponsors: [SPONSORS[4]] as Sponsor[],
	},
	{
		id: 't5-august',
		eventName: 'Prairie Landing',
		eventDate: '2025-08-16',
		eventTime: '13:00',
		eventTZ: 'America/Chicago',
		eventLocation:
			'Prairie Landing Golf Club, 2325 Longest Dr, West Chicago, IL 60185, United States',
		registrationOpenDate: '2025-07-20 08:00',
		registrationCloseDate: '2025-08-05',
		withdrawCloseDate: '2025-08-05',
		eventPrice: 130,
		imgSrc: '/img/events/prairie.png',
		totalSlots: 88,
		waitlistSlots: 32,
		sponsors: [SPONSORS[5], SPONSORS[0]] as Sponsor[],
	},
	{
		id: 't6-september',
		eventName: 'Broken Arrow',
		eventDate: '2025-09-13',
		eventTime: '13:00',
		eventTZ: 'America/Chicago',
		eventLocation:
			'Broken Arrow Golf Club, 16325 Broken Arrow Dr, Lockport, IL 60441, United States',
		registrationOpenDate: '2025-08-17 08:00',
		registrationCloseDate: '2025-09-03',
		withdrawCloseDate: '2025-09-03',
		eventPrice: 110,
		imgSrc: '/img/events/broken.webp',
		totalSlots: 88,
		waitlistSlots: 32,
		sponsors: [SPONSORS[3]] as Sponsor[],
	},
]

export const GUEST_EVENT = {
	id: 'guest-event',
}
